/**
 * Action constants
 * @type {string}
 */
export const RESET_ANALYSIS_FILTERS = "RESET_ANALYSIS_FILTERS"
export const UPDATE_ANALYSIS_FILTER = "UPDATE_ANALYSIS_FILTER"


const AnalysisActions = {}


AnalysisActions.resetFilters = () => {
  return {
    type: RESET_ANALYSIS_FILTERS
  }
}

/**
 * Update filters used on analysis page
 *
 * @param property
 * @param value
 * @returns {{type: string, property: *, value: *}}
 */
AnalysisActions.updateFilter = (property, value) => {
  return {
    type: UPDATE_ANALYSIS_FILTER,
    property,
    value
  }
}


export const resetFilters = AnalysisActions.resetFilters
export const updateFilter = AnalysisActions.updateFilter


export default AnalysisActions
